import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-257db58a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "world-cup-content" }
const _hoisted_2 = {
  key: 0,
  class: "world-cup-swiper-box"
}
const _hoisted_3 = { class: "world-cup-section-title world-cup-section-title-first" }
const _hoisted_4 = ["src", "alt", "onClick"]
const _hoisted_5 = { class: "world-cup-section-title" }
const _hoisted_6 = ["src", "alt", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.bannerImages.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode($setup["BannerSwiper"], {
            items: $setup.bannerImages,
            autoplay: $setup.bannerImages.length > 1 ? 4000 : 0,
            "image-field": "image_app_url",
            "fallback-image-field": "image_url",
            "image-fit": "cover",
            "box-padding": "0",
            "border-radius": "12px",
            "aspect-ratio": "1 / 0.45",
            "countdown-right": "4%",
            "background-color": $setup.bannerBgColor,
            "show-detail-button": false,
            onChange: $setup.onBannerChange
          }, null, 8 /* PROPS */, ["items", "autoplay", "background-color"])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.scheduleImages.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.t("home.worldCupSchedule")), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scheduleImages, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "world-cup-banner-box",
              key: item.id
            }, [
              _createElementVNode("img", {
                class: "world-cup-banner",
                src: $setup.getImageUrl(item),
                alt: item.title,
                onClick: ($event: any) => ($setup.onContentImageClick(item, $setup.scheduleImages, index))
              }, null, 8 /* PROPS */, _hoisted_4)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    ($setup.scoreImages.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString($setup.t("home.worldCupScore")), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scoreImages, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "world-cup-banner-box",
              key: item.id
            }, [
              _createElementVNode("img", {
                class: "world-cup-banner",
                src: $setup.getImageUrl(item),
                alt: item.title,
                onClick: ($event: any) => ($setup.onContentImageClick(item, $setup.scoreImages, index))
              }, null, 8 /* PROPS */, _hoisted_6)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["world-cup-section-title", { 'world-cup-section-title-first': $setup.bannerImages.length == 0 && $setup.scheduleImages.length == 0 && $setup.scoreImages.length == 0 }])
    }, _toDisplayString($setup.t("home.worldCupNews")), 3 /* TEXT, CLASS */),
    _createVNode($setup["Newsletter"], {
      query: $setup.worldCupNewsQuery,
      "page-event": "HomeWorldCupNews"
    })
  ]))
}